export const getStatusColor = (status) => {
    const statusColors = {
        'notfounf': 'lightgray',
        'Transit': '#5357DC',
        'Delivered': '#3EDC8B',
        'Cancelled': 'red',
    }
    return statusColors[status] || 'lightgray';
}